import React from "react";
import { Alert } from "@mui/material";
import AppModal from "../common/AppModal";
import CreateLicenseForm from "../../forms/CreateLicenseForm";

const CreateLicenseModal = ({ open, onClose, loading, error }) => {
  return (
    <AppModal
      open={open}
      onClose={onClose}
      title="Generate New License"
      width="md"
      loading={loading}
    >
      {error && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {error}
        </Alert>
      )}
      <CreateLicenseForm loading={loading} />
    </AppModal>
  );
};

export default CreateLicenseModal;
